var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDropup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.519,
    height: 13.519,
    viewBox: "0 0 13.519 13.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-dropup",
    "data-name": "Icon ionic-ios-arrow-dropup",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M10.165,16.332a.63.63,0,0,1,0-.887l3.11-3.1a.627.627,0,0,1,.864-.019L17.2,15.38a.626.626,0,1,1-.884.887l-2.632-2.593-2.636,2.662A.627.627,0,0,1,10.165,16.332Z",
    transform: "translate(-3.554 -4.726)",
    fill: "#ff6145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M10.135,16.894a6.76,6.76,0,1,0-6.76-6.76A6.759,6.759,0,0,0,10.135,16.894Zm0-1.04a5.725,5.725,0,1,1,4.043-1.677A5.67,5.67,0,0,1,10.135,15.854Z",
    fill: "#ff6145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropup);
export default __webpack_public_path__ + "static/media/arrow-dropup.7f37a9581b4d3d9d71a59d9a92274baf.svg";
export { ForwardRef as ReactComponent };